// // MODIFIED
import React, { useState } from "react";
import LeaveRequestModule from "../../components/modules/LeaveRequest/LeaveRequestModule";
import LeaveRequestHistory from "../../components/modules/LeaveRequest/components/LeaveRequestHistory";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { useLeaveRequest } from "../../hooks/useLeaveRequest";
import { useEmployeeLeaveBalance } from "../../hooks/useEmployeeLeaveBalance"; // // ADDED
import { LoadingSpinner } from "../../../common/Loading"; // // MODIFIED: Corrected path

function LeaveRequestPage({ user, userAccess, isHideSideMenu }) {
  const [showHistoryModal, setShowHistoryModal] = useState(false);

  const currentEmployeePersonalInformationId = user?.employeePersonalInformationId;

  // // MODIFIED: Centralized hooks to share state between children
  const {
    requests,
    loading: requestLoading,
    formData,
    setFormData,
    handleInputChange,
    handleFileChange,
    submitRequest,
    showMessage,
    message,
    isSuccess
  } = useLeaveRequest(currentEmployeePersonalInformationId);

  const {
    employeeLeaveCredits,
    loading: balanceLoading,
    fetchBalances // Ensure this is returned from your useEmployeeLeaveBalance hook
  } = useEmployeeLeaveBalance(currentEmployeePersonalInformationId);

  const hasFullAccess = userAccess.isFullLeaveAccess;
  const isLoading = requestLoading || balanceLoading;

  return (
    <>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="MainteInfo shadow-xl bg-white rounded-lg">

            {/* Header */}
            <div className="mainteHeader p-4 border-b flex justify-between items-center">
              <div>
                <div className='sub-title row text-sm'>
                  <span className="text-gray-400">{"Transaction "} &gt; </span>
                  <span className="border-b border-black">{"Leave Request"}</span>
                </div>
                <h3 className="text-xl font-bold mt-2">Leave Request</h3>
              </div>

              <button
                onClick={() => setShowHistoryModal(true)}
                className="flex items-center bg-cyan-500 hover:bg-cyan-600 text-white px-4 py-2 rounded-md border-none cursor-pointer transition-colors shadow-sm font-medium"
              >
                <RemoveRedEyeIcon fontSize="small" className="mr-2" />
                VIEW HISTORY
              </button>
            </div>

            {hasFullAccess && (
              <div className="mb-6 p-4 bg-gray-100 rounded-lg border-dashed border-2 border-gray-300 text-center mx-4 mt-4">
                <p className="text-gray-600 font-medium">Administrator View: Select an Employee to manage their leaves.</p>
                <button className="mt-2 text-blue-600 underline">Open Employee Selector</button>
              </div>
            )}

            {/* // MODIFIED: Passing all state and refresh functions to the Module */}
            <LeaveRequestModule
              user={user}
              userAccess={userAccess}
              requests={requests}
              formData={formData}
              handleInputChange={handleInputChange}
              handleFileChange={handleFileChange}
              submitRequest={submitRequest}
              showMessage={showMessage}
              message={message}
              isSuccess={isSuccess}
              loading={isLoading}
              employeeLeaveCredits={employeeLeaveCredits}
              fetchBalances={fetchBalances}
            />
          </div>
        </div>
      </div>

      <LeaveRequestHistory
        isOpen={showHistoryModal}
        onClose={() => setShowHistoryModal(false)}
        data={requests || []}
      />

      {/* // MODIFIED: Spinner covers the whole page during any data operation */}
      <LoadingSpinner loading={isLoading} />
    </>
  );
}

export default LeaveRequestPage;